import { useParsed, useTranslation } from "@refinedev/core";
import { ReactNode } from "react";
import { CommonTemplate } from "./common";

export interface PublicTemplateProps {
    navbar?: JSX.Element
    tabbar?: JSX.Element
    sidebar?: JSX.Element
    navbarProps?: Record<string, any>
    children?: ReactNode
    /**
     * Content of the Navbar's "left" area
     */
    left?: string | number | React.ReactNode;
    /**
     * Content of the Navbar's "title" area
     */
    title?: string | number | React.ReactNode;
    /**
     * Content of the Navbar's "subtitle" area
     */
    subtitle?: string | number | React.ReactNode;
    /**
     * Content of the Navbar's "right" area
     */
    right?: string | number | React.ReactNode;
    /**
     * Content of the Navbar's "subnavbar" area
     */
    subnavbar?: string | number | React.ReactNode;
}

export function PublicTemplate({ children, navbar, subnavbar, navbarProps, left, title, subtitle, right }: PublicTemplateProps) {
    const parsed = useParsed();
    const { translate } = useTranslation();

    return <CommonTemplate>
        <div className="page bg-base-200 flex">
            <div className='w-full flex flex-col'>
                {navbar ?? <nav className="navbar bg-base-200 pb-0 min-h-12" {...navbarProps}>
                    <div className="navbar-start">
                        {left}
                    </div>
                    <div className="navbar-center flex flex-col leading-none">
                        <span className="font-bold text-xl">{title ?? (parsed.resource?.meta?.label ? translate(parsed.resource?.meta?.label) : parsed.pathname)}</span>
                        {subtitle ? <span className="font-light">{subtitle}</span> : <></>}
                    </div>
                    <div className="navbar-end">
                        {right}
                    </div>
                </nav>}
                {subnavbar ? <nav className="navbar pt-0">
                    {subnavbar}
                </nav> : <></>}
                <div className="w-full scrollbar-thin overflow-y-auto flex-1 flex flex-col">
                    {children}
                </div>
            </div>
        </div>
    </CommonTemplate>
}
